import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import * as actionTypes from "../../../../store/actions";
import "../ResultsButtons.css";
import ResultBtn from "../ResultBtn";
import ResultAlert from "../ResultAlert";
import generateExamBilet from "../../../../shared/functions/generateExamBilet";


const ResultsButtons = (props) => {
  const [showButton, setShowButton] = useState(false);

  const onResultBtnClick = async (btnType) => {
    props.resetNumbersStateArray();
    props.setClickedAnswerId(null);
    // для экзамена в случае повтора билета обрезаем количество заданий до первоначального числа
    if (props.categoryTickets === "examAB" ||
      props.categoryTickets === "examCD") {
      props.setLoadedBilet({ ...props.loadedBilet, tasks: props.loadedBilet.tasks.slice(0, 20) })
    }


    if (btnType === "next")
      props.setLoadedBilet(props.ticketsArray[incrementedTicketId - 1]);
    else if (btnType === "generate") {
      const generatedBilet = await generateExamBilet(props.categoryTickets);
      props.setLoadedBilet(generatedBilet);
     /*  props.setLoadedBilet(generateExamBilet(props.categoryTickets)); */
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowButton(true);
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  /*  Подмена ссылки в кнопках следующий билет и повторить билет */
  let incrementedTicketId;
  if (parseInt(props.paramsTicketId) !== props.ticketsArray.length) {
    incrementedTicketId = parseInt(props.paramsTicketId) + 1;
  } else incrementedTicketId = 1;
  /* Конец ----- Подмена ссылки в кнопках следующий билет и повторить билет */
  return (
    <div>
      {showButton ? (
        <div className="result-buttons">
          <ResultBtn
            onClickFunction={onResultBtnClick}
            link={
              props.categoryTickets === "examAB" ||
                props.categoryTickets === "examCD" ||
                props.categoryTickets === "newAB" ||
                props.categoryTickets === "newCD"
                ? `/${props.categoryTickets}/${1}`
                : `/${props.categoryTickets}/${props.paramsTicketId}/${1}`
            }
            btnText={"Повторить билет"}
          />
          {props.categoryTickets === "examAB" ||
            props.categoryTickets === "examCD" ? (
            <ResultBtn
              onClickFunction={() => onResultBtnClick("generate")}
              link={`/${props.categoryTickets}/${1}`}
              btnText={"Сгенерировать новый билет"}
            />
          ) : props.categoryTickets === "newAB" ||
            props.categoryTickets === "newCD" ?
            ""
            :
            (
              <ResultBtn
                onClickFunction={() => onResultBtnClick("next")}
                link={`/${props.categoryTickets}/${incrementedTicketId}/${1}`}
                btnText={"Следующий билет"}
              />
            )}
        </div>
      ) : props.isPassed ? (
        <ResultAlert type={"pass"} />
      ) : (
        <ResultAlert type={"not-pass"} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loadedBilet: state.ticketsReducer.loadedBilet,
    ticketsArray: state.ticketsReducer.ticketsArray,
    paramsTicketId: state.router.location.pathname.split("/")[2],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetNumbersStateArray: () =>
      dispatch({ type: actionTypes.RESET_NUMBERS_STATE_ARRAY }),
    setClickedAnswerId: (id) =>
      dispatch({
        type: actionTypes.SET_CLICKED_ANSWER_ID,
        clickedAnswerId: id,
      }),
    setLoadedBilet: (loadedBilet) =>
      dispatch({
        type: actionTypes.SET_LOADED_BILET,
        loadedBilet: loadedBilet,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsButtons);
